import { RootState } from "@/store/dtm";
import { applicationType, applicationCategory  } from "@/types/applicationType"
import { createSlice, PayloadAction } from "@reduxjs/toolkit"


export interface applicationState {
    application: applicationType,
}

const initialState: applicationState = {
    application: {
        id: 0,
        status: "",
        applicationCategory: 0,
        searchingForProperty: false,
        termLength: "",
        amortizationLength: 0,
        downPayment: 0,
        totalLoan: 0,
        productId: [],
        isCoApplicant: false,
        jointCode: "",
        jointRelationship: "",
        jointPrimaryApplicant: "",
        jointAccepted: false,
        products: [],
        selectedProducts: [],
        promoCode: "",
        applicationEndpointReached: false,
        applicationErrorCode: "",
        applicationErrorMessage: "",
        applicationProgress: 0,
        skipAlloy: (document.querySelector('meta[data-skip-alloy]') as HTMLElement | null)?.dataset?.skipAlloy == "true",
        alloyApplicationToken: "",
        blResult: false,
        welcomeEmailSent: false,
        idVerificationSubmitted: false,
        underStaffReview: false,
        purchaseTypeSelected: false,
    }
}

export const applicationSlice = createSlice({
    name: "applicaton",
    initialState,
    reducers: {
        setApplicationId: (state, action: PayloadAction<number>) => {
            state.application.id = action.payload;
        },
        setApplicationStatus: (state, action: PayloadAction<string>) => {
            state.application.status = action.payload;
        },
        setApplicationCategory: (state, action: PayloadAction<applicationCategory>) => {
            state.application.applicationCategory = action.payload;
        },
        setSearchingForProperty: (state, action: PayloadAction<boolean>) => {
            state.application.searchingForProperty = action.payload;
        },
        setTermLength: (state, action: PayloadAction<number | string>) => {
            state.application.termLength = action.payload;
        },
        setAmortizationLength: (state, action: PayloadAction<number | string>) => {
            state.application.amortizationLength = action.payload;
        },
        setDownPayment: (state, action: PayloadAction<number>) => {
            state.application.downPayment = action.payload;
        },
        setTotalLoan: (state, action: PayloadAction<number>) => {
            state.application.totalLoan = action.payload;
        },
        addProductId: (state, action: PayloadAction<string>) => {
            const productid = action.payload.split(";");
            state.application.productId = productid;
        },
        setApplicationErrorCode: (state, action: PayloadAction<string>) => {
            const errorCode = action.payload;
            state.application.applicationErrorCode = errorCode;
        },
        setApplicationErrorMessage: (state, action: PayloadAction<string>) => {
            const message = action.payload;
            state.application.applicationErrorMessage = message;
        },
        clearApplicationState: (state) => {
            state.application.id = 0;
            state.application.status = "";
            state.application.applicationCategory = 0;
            state.application.searchingForProperty = false;
            state.application.termLength = 0;
            state.application.amortizationLength = 0;
            state.application.downPayment = 0;
            state.application.totalLoan = 0;
            state.application.isCoApplicant = false;
            state.application.productId = [];
            state.application.selectedProducts = [];
            state.application.promoCode = "";
            state.application.jointCode = "";
            state.application.jointRelationship = "";
            state.application.jointPrimaryApplicant = "";
            state.application.applicationEndpointReached = false,
            state.application.jointAccepted = false;
            state.application.applicationErrorCode = "";
            state.application.applicationErrorMessage = "";
            state.application.applicationProgress = 0;
            state.application.skipAlloy = (document.querySelector('meta[data-enable-alloy]') as HTMLElement | null)?.dataset?.enableAlloy != "true";
            state.application.alloyApplicationToken = "";
            state.application.blResult = false;
            state.application.welcomeEmailSent = false;
            state.application.idVerificationSubmitted = false;
            state.application.underStaffReview = false;
            state.application.purchaseTypeSelected = false;
        },
        setIsCoApplicant: (state, action: PayloadAction<boolean>) => {
            state.application.isCoApplicant = action.payload;
        },
        setPromoCode: (state, action: PayloadAction<string>) => {
            state.application.promoCode;
        },
        setApplicationProducts: (state, action: PayloadAction<any[]>) => {
            state.application.products = action.payload;
        },
        setJointCode: (state, action: PayloadAction<string>) => {
            state.application.jointCode = action.payload;
        },
        setJointRelationship: (state, action: PayloadAction<string>) => {
            state.application.jointRelationship = action.payload;
        },
        setJointPrimaryApplicant: (state, action: PayloadAction<string>) => {
            state.application.jointPrimaryApplicant = action.payload;
        },
        setJointAccepted: (state, action: PayloadAction<boolean>) => {
            state.application.jointAccepted = action.payload;
        },
        setSelectedProducts: (state, action: PayloadAction<any[]>) => {
            state.application.selectedProducts = action.payload;
        },
        setApplicationEndpointReached:(state, action: PayloadAction<boolean>) => {
            state.application.applicationEndpointReached = action.payload
        },
        setApplicationProgress: (state, action: PayloadAction<number>) => {
            state.application.applicationProgress = action.payload;
        },
        setSkipAlloy:(state, action: PayloadAction<boolean>) => {
            state.application.skipAlloy = action.payload
        },
        setAlloyApplicationToken: (state, action: PayloadAction<string>) => {
            state.application.alloyApplicationToken = action.payload;
        },
        setBlResult:(state, action: PayloadAction<boolean>) => {
            state.application.blResult = action.payload
        },
        setWelcomeEmailSent: (state, action: PayloadAction<boolean>) => {
            state.application.welcomeEmailSent = action.payload
        },
        setIdVerificationSubmitted: (state, action: PayloadAction<boolean>) => {
            state.application.idVerificationSubmitted = action.payload
        },
        setUnderStaffReview: (state, action: PayloadAction<boolean>) => {
            state.application.underStaffReview = action.payload
        },
        setPurchaseTypeSelected: (state, action: PayloadAction<boolean>) => {
            state.application.purchaseTypeSelected = action.payload
        }
    }
});

export const {
    setApplicationId,
    setApplicationStatus,
    setApplicationCategory,
    setSearchingForProperty,
    setTermLength,
    setAmortizationLength,
    setDownPayment,
    setTotalLoan,
    addProductId,
    clearApplicationState,
    setIsCoApplicant,
    setApplicationProducts,
    setSelectedProducts,
    setPromoCode,
    setJointCode,
    setJointRelationship,
    setJointPrimaryApplicant,
    setJointAccepted,
    setApplicationEndpointReached,
    setApplicationErrorCode,
    setApplicationErrorMessage,
    setApplicationProgress,
    setSkipAlloy,
    setAlloyApplicationToken,
    setBlResult,
    setWelcomeEmailSent,
    setIdVerificationSubmitted,
    setUnderStaffReview,
    setPurchaseTypeSelected
} = applicationSlice.actions;

export const selectApplication = (state: RootState) => state.application;
export const selectApplicationProducts = (state: RootState) => state.application.application.products;

export default applicationSlice.reducer